import type { CellContext, ColumnDef } from "@tanstack/react-table";
import dayjs from "dayjs";

import type { IAccessTokens } from "./types";

export const getColumns = (
  t: (key: string) => string,
  lastAccessTokenUseFromNow: (lastTokenUse: string | null) => string,
  handleRevoke: (token: IAccessTokens) => JSX.Element,
): ColumnDef<IAccessTokens>[] => {
  const SECONDS_IN_MS = 1000;

  return [
    {
      accessorKey: "name",
      header: t("updateAccessToken.header.name"),
      size: 200,
    },
    {
      accessorKey: "issuedAt",
      cell: (cell: CellContext<IAccessTokens, unknown>): string =>
        dayjs(cell.row.original.issuedAt * SECONDS_IN_MS).format("YYYY-MM-DD"),
      header: t("updateAccessToken.header.issuedAt"),
      size: 150,
    },
    {
      accessorKey: "lastUse",
      cell: (cell: CellContext<IAccessTokens, unknown>): string =>
        lastAccessTokenUseFromNow(cell.row.original.lastUse),
      header: t("updateAccessToken.header.lastUse"),
      size: 150,
    },
    {
      accessorKey: "action",
      cell: (cell: CellContext<IAccessTokens, unknown>): JSX.Element =>
        handleRevoke(cell.row.original),
      enableSorting: false,
      header: "",
      size: 100,
    },
  ];
};
